import { render } from "./SelectorCamp.vue?vue&type=template&id=e22db996&scoped=true"
import script from "./SelectorCamp.vue?vue&type=script&lang=js"
export * from "./SelectorCamp.vue?vue&type=script&lang=js"

import "./SelectorCamp.vue?vue&type=style&index=0&id=e22db996&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e22db996"]])

export default __exports__